import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { StrategiesService, Indicator, SymbolSearchService, defaultAlgoParams, AlgoStrategy, EventsService } from '@app/_shared/providers';
import { COMPARATORS, CANDLE_OPTIONS, StrategyFormBuildMode, EXECUTION_STYLE } from '../../strategy.enums';
import { ADVANCE_INDICATOR_INPUT_TYPE } from '../advance-indicator-form/advance-indicator-form.enums';
import { Router } from '@angular/router';
import { isEqual, find, cloneDeep } from 'lodash-es';
import { Utils, CURRENCY_LABEL } from '@app/_helpers';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { StrategyParamsFormComponent } from '../strategy-params-form/strategy-params-form.component';
import { retry } from 'rxjs/operators';
import { promise } from 'protractor';
import { NgxToastrService } from '@app/_shared/providers';


declare var webkitSpeechRecognition: any;

interface DataObj {
    key: string;
    value: any;
    showOptions: boolean;
    valueArray?: string[];
}

@Component({
    selector: 'app-text-builder-mode',
    templateUrl: './text-builder-mode.component.html',
    styleUrls: ['./text-builder-mode.component.scss']
})


export class TextBuilderModeComponent implements OnInit {

    @Input('executionStyle') executionStyle: EXECUTION_STYLE;
    recognizing = false;
    microphoneAccessGranted: boolean;
    recognition = new webkitSpeechRecognition();
    textInput = '';
    formControlValue = '';
    indicatorList: Indicator[] = [];
    indicators = [];
    comparators = [];
    candleOptions = [];
    symbols = [];
    regExps = [];

    dataObj: DataObj[] = [];

    entryOrder = ['action', 'quantity', 'share_type', 'symbol', 'parameter', 'comparator',
        'parameter_value', 'candle_size'];

    currentPosition = -1;

    globalRegEx = '^(buy|sell) ';

    isEditing = false;

    autoCompleteArray = [];

    oldData: AlgoStrategy;

    helpText = "Buy 3 Lots of NSECM ACC EQ when LTP Crosses Over 23 on 15 min candle";

    errorMessage = {
        0: 'Please add action',
        1: 'Please add quantity',
        2: 'Please add share type',
        3: 'Please add symbol',
        4: 'Please add parameter',
        5: 'Please add comparator',
        6: 'Please add parameter value',
        7: 'Please add candle size'
    }
    constructor(
        private strategyService: StrategiesService,
        private symbolSearchService: SymbolSearchService,
        private router: Router,
        private dialog: MatDialog,
        private eventsService: EventsService,
        private snackBar: NgxToastrService

    ) {

        this.strategyService.getIndicatorsList().subscribe(res => {
            this.indicatorList = res;
            this.indicators = this.indicatorList.map(el => el.name);
            this.initData();
        });
        this.getSymbols();
        this.getPermission();
    }


    ngOnInit(): void {
    }

    initData() {
        // const symbolRegex = await this.getSymbolRegEx();
        this.regExps = [
            ' ',
            `(${CURRENCY_LABEL})?\\d+(\\.\\d{1,4})? `,
            '(value shares|lots) ',
            '[a-zA-Z0-9 .]+ ',
            this.getParameterRegex(),
            this.getComparators(),
            this.getSecondParameterRegex(),
            this.getCandleSize()
        ];


        /**
         * Sets input format to
         * "BUY|SELL <NUMBER> <STOCKS|LOTS> of <SYMBOL> when <PARAMETER> <COMPARATOR> <Value>
         * on <CANDLESIZE> candle"
         */
        this.dataObj = [
            {
                key: 'action',
                value: '',
                showOptions: true,
                valueArray: ['Buy', 'Sell']
            }, {
                key: 'quantity',
                value: 0,
                showOptions: false
            }, {
                key: 'share_type',
                value: '',
                showOptions: true,
                valueArray: ['Value Shares', 'Lots']
            }, {
                key: 'symbol',
                value: '',
                showOptions: true
                // symbol search
            }, {
                key: 'parameter',
                value: '',
                showOptions: true,
                valueArray: this.indicators
            }, {
                key: 'comparator',
                value: '',
                showOptions: true,
                valueArray: this.comparators
            }, {
                key: 'parameter_value',
                value: 1,
                showOptions: true,
                valueArray: this.indicators
            }, {
                key: 'candle_size',
                value: '',
                showOptions: true,
                valueArray: this.candleOptions
            }
        ];
        this.updateAutoCompleteArray();

    }

    async checkForPermission() {
        try {
            const microphone = await navigator.permissions.query({ name: 'push' }); // TODO: change to microphone   
            this.microphoneAccessGranted = microphone.state != 'denied';
        } catch (e) {
            console.error('Error occured while checking site permissions ', e);
        }
    }


    async getPermission() {
        await this.checkForPermission();

        navigator.mediaDevices.getUserMedia({ audio: this.microphoneAccessGranted }).then((stream) => {
            console.log('use mic');
        }).catch((err) => {
            console.log('No mic for u');
        })

    }


    mainFunc() {

        const speechRecognition = (window as any).SpeechRecognition || window['webkitSpeechRecognition'];
        if (typeof speechRecognition === 'undefined') {
            console.log('No Support');
        } else {
            const result = document.getElementById('result');

            this.recognition.continuous = true;
            // this.reset();
            // this.recognition.onend = this.reset();
            this.recognition.onresult = (event) => {
                result.innerHTML = "";
                for (let i = event.resultIndex; i < event.results.length; ++i) {
                    const text = document.createTextNode(event.results[i][0].transcript);
                    const p = document.createElement('p');
                    if (event.results[i].isFinal) {
                        p.classList.add("final");
                    }
                    p.appendChild(text);
                    result.appendChild(p);
                }

            }
        }
    }


    reset() {
        this.recognizing = false;

    }

    start() {
        if (this.recognizing) {
            this.recognition.stop();
            this.reset();
        } else {
            this.recognition.start();
            this.recognizing = true;
            this.mainFunc();

        }
    }

    micClicked() {
        console.log('Clicked');
    }

    submit() {
        this.strategyService.detectParamsFromText(this.textInput).subscribe(res => {
            console.log(res);
        })
    }

    // Fuction to filter choices

    findChoices(searchText: string) {
        return this.autoCompleteArray.filter(item =>
            item.toLowerCase().includes(searchText.toLowerCase())
        );
    }

    //  returns label abter option is clicked

    getChoiceLabel(choice: any) {
        return `${choice.key} `;
    }

    selectedOption(event: any) {
        if (this.currentPosition === 4 || this.currentPosition === 6) {
            this.openValueDialog(event.choice.key);
        }
    }

    // Gets Parameter values

    openValueDialog(indicator: string) {
        if (!indicator) {
            return;
        }
        const indicatorObject = find(this.strategyService.params, (params) => params.name === indicator);
        if (!indicatorObject.inputParamterObjects.length) {
            const valueStr = Utils.formatIndicatorValueString(this.formControlValue, null);
            this.formControlValue = valueStr;
            // inputEventHandler called explicitly to match regex with input so that new
            // auto complete array is updated and current position is incremented.
            this.inputEventHandler('', this.formControlValue)
            return;
        }
        const dialog = this.dialog.open(StrategyParamsFormComponent, {
            data: indicator
        });

        dialog.afterClosed().subscribe(data => {

            const valueStr = Utils.formatIndicatorValueString(this.formControlValue, Object.values(data)) + ' ';

            this.formControlValue = valueStr;
            // inputEventHandler called explicitly to match regex with input so that new
            // auto complete array is updated and current position is incremented.
            this.inputEventHandler('', this.formControlValue)
        });
    }

    inputEventHandler(event: any, parValue?: string) {
        const value = parValue ? parValue : event.srcElement['value'].toLowerCase();
        const regex = new RegExp(this.globalRegEx, "i");

        if (regex.test(value)) {
            this.addAutoCompleteWords();
            this.currentPosition += 1;
            this.updateRegExp();
        }
    }

    addAutoCompleteWords() {

        switch (this.currentPosition) {

            case 2:
                const temp = this.formControlValue.trim().split(' ');
                const isShares = temp[temp.length - 1] === 'Shares';
                if (isShares) {
                    temp[1] = Utils.currencyString(temp[1]);
                    this.formControlValue = temp.join(' ') + ' ';
                }
                this.formControlValue = this.formControlValue + 'of ';
                this.globalRegEx = this.globalRegEx.concat('of ');
                break;

            case 3:
                this.formControlValue = this.formControlValue + 'when ';
                this.globalRegEx = this.globalRegEx.concat('when ');
                break;

            case 4:
                if (!this.formControlValue.endsWith(' ')) {
                    this.formControlValue = this.formControlValue + ' ';
                    this.globalRegEx = this.globalRegEx.concat(' ');
                }
                break;

            case 6:
                /** Ticket: RA-667
                 *
                 * Issue: regEx at this point expects a number and as soon as it gets one,
                 * it moves ahead, so the possibility of entring multi digit number is not
                 * present directly.
                 *
                 * Expanation:
                 * In case of currentPosition as 6 as can have a number or an indicator
                 * In case of number, we only update the regEx when the user presses space
                 * marking the end of number, in that case we explicitly do not need to add
                 * more space. But in case of indicator, another space has to be added
                 * programatically.
                 */
                let addition = 'on ';
                if (!this.formControlValue.endsWith(' ')) {
                    addition = ' on '
                }
                this.formControlValue = this.formControlValue + addition;
                this.globalRegEx = this.globalRegEx.concat(addition);
                break;

            case 7:
                this.formControlValue = this.formControlValue + 'candle ';
                this.globalRegEx = this.globalRegEx.concat('candle ');
                break;

        }
    }


    extractData() {

        if (this.currentPosition > 7) {
            let data = this.formControlValue;

            // Extract Action
            this.dataObj.find(el => el.key === this.entryOrder[0]).value = data.split(' ')[0];

            // Extract Quantity
            this.dataObj.find(el => el.key === this.entryOrder[1]).value = data.split(' ')[1].replace(CURRENCY_LABEL, '');

            // Extract Share Type
            this.dataObj.find(el => el.key === this.entryOrder[2]).value = data.split(' ')[2];

            // Extract Symbol
            const symbolSelected = data.substring(data.indexOf('of ') + 3, data.indexOf('when') - 1);
            const symbolObj = this.symbols.filter(el => el.key === symbolSelected).map(el => {
                return el.value
            });
            this.dataObj.find(el => el.key === this.entryOrder[3]).value = symbolObj;

            // Extract Parameters
            this.dataObj.find(el => el.key === this.entryOrder[4]).value = data.substring(data.indexOf('when ') + 5).split(' ')[0];

            // Extract Comparator
            const array = data.substring(data.indexOf('when ') + 5).split(' ');
            const index = array.indexOf('on');
            const comparator = array.slice(1, index - 1).join(' ');
            this.dataObj.find(el => el.key === this.entryOrder[5]).value = comparator;

            // Extract Parameter Value
            this.dataObj.find(el => el.key === this.entryOrder[6]).value = array.slice(1, index).slice(-1)[0];


            // Extract Candle
            this.dataObj.find(el => el.key === this.entryOrder[7]).value = data.substring(data.indexOf('on ')).split(' ').splice(1, 2).join(' ');



            this.fillStrategyObj();
        }
        else {
            this.snackBar.simpleCustomToaster(this.errorMessage[this.currentPosition]);
        }
    }

    updateRegExp() {
        if (this.regExps[this.currentPosition]) {
            this.globalRegEx = this.globalRegEx.concat(this.regExps[this.currentPosition]);
        } else if (this.globalRegEx.charAt(this.globalRegEx.length - 1) !== '$') {
            this.globalRegEx = this.globalRegEx.concat('$');
        }
        this.updateAutoCompleteArray();
    }


    // Updates auto complete array that is shown as dropdown
    updateAutoCompleteArray() {
        this.currentPosition = this.currentPosition === -1 ? 0 : this.currentPosition;
        const value = this.dataObj.find(el => el.key === this.entryOrder[this.currentPosition]);
        if (value && value.showOptions) {

            // In case of symbol
            if (this.currentPosition === 3) {
                this.autoCompleteArray = this.symbols;
            } else {
                this.autoCompleteArray = value.valueArray.map(el => {
                    return {
                        key: el,
                        value: el
                    }
                })
            }

        }
    }


    fetchParameterArray(key: string, indicatorInputType = ADVANCE_INDICATOR_INPUT_TYPE.INDICATOR) {
        const parameterArray = [];
        const parameterValue = this.dataObj.find(el => el.key === key).value;

        if (indicatorInputType === ADVANCE_INDICATOR_INPUT_TYPE.NUMBER) {
            return [parameterValue]
        }

        parameterArray.push(parameterValue.split('(')[0].trim());

        parameterArray.push(...parameterValue.substring(
            parameterValue.lastIndexOf('(') + 1,
            parameterValue.lastIndexOf(')')
        ).split(',').map(el => {
            if (el.length > 0) {
                return el.trim()
            }
        }));

        parameterArray.forEach((el, idx) => {
            if (el === undefined) {
                parameterArray.splice(idx, 1);
            }
        });
        return parameterArray;
    }

    fillStrategyObj() {
        const defaultParams = cloneDeep(defaultAlgoParams);
        defaultParams.strategyMode = StrategyFormBuildMode.TEXT_BUILDER;
        defaultParams.executionStyle = this.executionStyle;
        defaultParams.orderMode = this.dataObj.find(el => el.key === 'action').value;
        defaultParams.orderQty = this.dataObj.find(el => el.key === 'quantity').value;
        defaultParams.isLot = this.dataObj.find(el => el.key === 'share_type').value === 'Lots';
        defaultParams.symbols = this.dataObj.find(el => el.key === 'symbol').value;
        defaultParams.candleSize = this.dataObj.find(el => el.key === 'candle_size').value;

        const indicatorInputType =
            isNaN(this.dataObj.find(el => el.key === 'parameter_value').value / 1) ?
                ADVANCE_INDICATOR_INPUT_TYPE.INDICATOR :
                ADVANCE_INDICATOR_INPUT_TYPE.NUMBER;


        const parameterArray = this.fetchParameterArray('parameter');
        const parameterValue = this.fetchParameterArray('parameter_value', indicatorInputType);

        const indicators = [
            {
                name: parameterArray[0],
                type: ADVANCE_INDICATOR_INPUT_TYPE.INDICATOR,
                params: parameterArray.slice(1)
            },
            {
                name: this.dataObj.find(el => el.key === 'comparator').value,
                type: ADVANCE_INDICATOR_INPUT_TYPE.COMPARATOR,
                params: []
            },
            {
                name: parameterValue[0],
                type: indicatorInputType,
                params: parameterValue.slice(1)
            }
        ];


        defaultParams.entryIndicatorRow.indicatorRow = [{
            indicators: indicators
        }];

        // Need to set to Null explicitly
        defaultParams.exitIndicatorRow = {
            indicatorRow: undefined,
            rowComparator: undefined
        };

        defaultParams.generateIndicatorStrings(this.symbolSearchService);

        if (this.isEditing) {
            defaultParams.algoName = this.oldData.algoName;
            defaultParams.algoNotes = this.oldData.algoNotes;
            defaultParams.id = this.oldData.id;
        }


        this.router.navigate(['/trading/strategies/confirmation'], {
            state: {
                algo: defaultParams
            }
        })

    }

    // getSymbolRegEx() {
    //     return new Promise((res) => {
    //         let retRegex = '(';
    //         this.getSymbols().then((symbols: any[]) => {
    //             symbols.forEach((el, idx) => {
    //                 retRegex = retRegex.concat(`${el.key}`)
    //                 if (idx !== symbols.length - 1) {
    //                     retRegex = retRegex.concat('|')
    //                 }
    //             })
    //             res(`${retRegex}) `);
    //         });
    //     });
    // }

    getSymbols() {
        return new Promise((res) => {
            if (this.symbols.length) {
                res(this.symbols);
            }
            this.symbolSearchService.onLoad.subscribe(loaded => {
                if (loaded) {
                    this.symbols = this.symbolSearchService.symbolSearchResultsarray.map(el => {
                        return {
                            key: el.market_id + ' ' + el.scrip_name,
                            value: {
                                security_id: el.security_id,
                                market_id: el.market_id
                            }
                        }
                    });
                    res(this.symbols);
                }
            });
        })
    }


    async setTextValue(form: AlgoStrategy) {
        await this.getSymbols();

        this.oldData = form;
        this.formControlValue = this.getStrategyString(form);
        this.isEditing = true;
        this.currentPosition = 8;
    }

    getStrategyString(form: AlgoStrategy) {
        const indicators = form.entryIndicatorRow.indicatorRow[0].indicators;

        const indicatorInputType =
            isNaN(<any>indicators[2].name / 1) && indicators[2].params.length ?
                1 :
                0;


        return `${form.orderMode} ${form.isLot ? '' : CURRENCY_LABEL}${form.orderQty} ${form.isLot ? 'Lots' : 'Value Shares'} of ${this.symbols.find(el => isEqual(el.value, form.symbols[0])).key} when ${indicators[0].name}${indicators[0].params.length ? `(${indicators[0].params})` : ''} ${indicators[1].name} ${indicators[2].name}${indicatorInputType ? `(${indicators[2].params})` : ''} on ${form.candleSize} candle`;
    }


    get showAutoCompleteOptions() {
        let index = -1;
        index = this.dataObj.findIndex(el => el.key === this.entryOrder[this.currentPosition]);
        if (index > -1) {
            return this.dataObj[index].showOptions;
        }
        return false;
    }

    getParameters() {
        return `(${this.indicators.join('|')}) `;

    }

    /**
     * Generates a regular expression out of list of indicators,
     * based on weather it accepts any parameter or not.
     *
     * @returns retRegex as a string
     * @memberof TextBuilderModeComponent
     */
    getParameterRegex() {
        let retRegex = '(';
        this.indicators.forEach((indicator, idx) => {
            const indicatorObject = find(this.strategyService.params, (params) => params.name === indicator);
            if (!indicatorObject.inputParamterObjects.length) {
                // No Parameter
                retRegex = retRegex.concat(`${indicator.trim()}`);
            } else {
                retRegex = retRegex.concat(`${indicator.trim()}\\([a-zA-Z0-9 ,]*\\)`)
            }

            if (idx !== this.indicators.length - 1) {
                retRegex = retRegex.concat('|');
            }
        });

        return `${retRegex}) `;
    }

    getSecondParameterRegex() {
        return `(${this.getParameterRegex()}|\\d+(\\.\\d{1,4})? )`;
    }

    getComparators() {
        this.comparators = Object.values(COMPARATORS);
        return `(${this.comparators.join('|')}) `;
    }

    getCandleSize() {
        this.candleOptions = Object.values(CANDLE_OPTIONS);
        return `(${this.candleOptions.join('|')}) `;
    }

}
